export const selectedOwner = (payload, closing) => ({
  type: 'SELECTED_OWNER',
  payload,
  closing,
});

export const clearItem = () => ({
  type: 'CLEAR_ITEM',
});
